import { Pipe, PipeTransform } from '@angular/core';

import {AttributeMappingDirection, IntegrationTaskMap} from '@app/views/admin/application-settings/models/integration-task-map.model';

@Pipe({
    name: 'getSourcePropertyDisableStatus'
})
export class GetSourcePropertyDisableStatusPipe implements PipeTransform {

    constructor() { }

    transform(
        mappedSourcePropertyNamesObj: {},
        availableTargetAttributesObj: {},
        mapping: IntegrationTaskMap,
        buttonDirection: AttributeMappingDirection,
        taskId: string
    ): boolean {

        let disable = false;
        const sourcePropertyName = mapping.direction === AttributeMappingDirection.IMPORT
            ? mapping.sourcePropertyName : mapping.backToSourcePropertyName;
        if ((buttonDirection === AttributeMappingDirection.EXPORT) && mapping.targetProperty.required) {
            // Don't allow Export mapping direction if target attribute is required
            disable = true;
        } else {
            if (mapping.backToSourcePropertyName && (buttonDirection === AttributeMappingDirection.IMPORT) && mapping.sourceProperty.required) {
                // Don't allow Import mapping direction if source (b2s) attribute is required
                disable = true;
            } else {
                if (mapping.direction !== buttonDirection) {
                    if (mapping.direction === AttributeMappingDirection.IMPORT) {

                        // check disable status based on source attribute
                        if (sourcePropertyName &&
                            ((buttonDirection === AttributeMappingDirection.EXPORT)
                                || (buttonDirection === AttributeMappingDirection.SYNC))) {

                            disable = mappedSourcePropertyNamesObj[sourcePropertyName];
                        }


                        if (!disable && (mapping.direction === AttributeMappingDirection.IMPORT)) {
                            disable = !!((!mapping.sourcePropertyName && mapping.backToSourcePropertyName)
                                || (mapping.sourcePropertyName && mapping.backToSourcePropertyName));
                        }
                    } else {

                        // check disable status based on target attribute
                        if (mapping.targetPropertyName && (mapping.direction === AttributeMappingDirection.EXPORT)) {
                            disable = !availableTargetAttributesObj[mapping.targetPropertyName];
                        }

                        if (sourcePropertyName
                            && mappedSourcePropertyNamesObj[sourcePropertyName]
                            && mappedSourcePropertyNamesObj[sourcePropertyName].length > 1
                            && (buttonDirection === AttributeMappingDirection.SYNC || buttonDirection === AttributeMappingDirection.EXPORT)) {
                            disable = mappedSourcePropertyNamesObj[sourcePropertyName].includes(taskId + mapping.mappingIndex);
                        }
                    }
                }
            }
        }

        return disable;
    }
}
